import styled from 'styled-components';
import MessageInput from './MessageInput';
import InputIcon from './InputIcon';
import { InputProps } from './types';

const getIcon = (icon: string) => `${icon}`;

const Input = (props: InputProps) => {
  const { disabled = false, hasError = false, icon = 'no icon' } = props;

  return (
    <InputWrapper
      className={`${getIcon(icon)} ${hasError ? 'error' : ''} ${icon !== 'no icon' ? 'hasIcon' : ''} ${
        disabled ? 'disabled' : ''
      }`}
    >
      <MessageInput {...props} />
      {icon !== 'no icon' && <InputIcon icon={icon} hasError={hasError} disabled={disabled} />}
    </InputWrapper>
  );
};

export default Input;

const InputWrapper = styled.div`
  position: relative;
  max-width: 500px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid #8e9697;

  .input {
    box-sizing: border-box;
    width: 100%;
    border-radius: 6px;
    height: 50px;
    font-weight: 400;
    color: #17233c;
    font-size: 16px;
    line-height: 1.25;
    border: none !important;
    background-color: white;
    padding: 12px 12px 8px 12px;
    outline: none;
  }
  &.hasIcon {
    .input {
      padding: 12px 44px 12px 12px;
    }
  }
  &:hover {
    .input {
      border: 1px solid #5e696a;
    }
    svg {
      path {
        fill: #5e696a;
      }
    }
  }
  &:active {
    .input {
      color: #17233c;
      border: 1px solid #17233c;
    }
    svg {
      path {
        fill: #17233c;
      }
    }
  }
  &.disabled {
    .input {
      color: #dbdfe5;
      border: 1px solid #dbdfe5;
    }
  }
  &.error {
    .input {
      color: #bc350a;
      border: 1px solid #bc350a;
    }
  }
`;
